import {
  DashoardSvg,
  AnalyticsSvg,
  ResumeSvg,
  JobPostSvg,
  EmployeesSvg,
  DetailsSvg,
  CalendarSvg,
  InboxSvg,
  CandidatesSvg,
  HotIcon,
  SettingIcon,
  NotificationIcon,
  TranslateIcon,
  Dropdown,
  // AnalyticsOptionItemEllipse,
  SearchIcon,
} from "../../components/svgs/svgs";

import Newmoilsvg from "../../Assets/newmoilsvg.svg";
import UserAvatar from "../../components/avatar/avatar";
import Moil from "../../Assets/moil.png";
import User from "../../Assets/memoji.png";/* 
import JobSeekerSidebar from "../../components/sidebar/sidebar_job_seeker";
import EmployerSidebar from "../../components/sidebar/sidebar_employer"; */
import profilephoto1 from "../../Assets/profilephoto1.svg";
import fivestars from "../../Assets/fivestars.svg";

export default {
  DashoardSvg,
  AnalyticsSvg,
  ResumeSvg,
  JobPostSvg,
  EmployeesSvg,
  DetailsSvg,
  CalendarSvg,
  InboxSvg,
  CandidatesSvg,
  HotIcon,
  SettingIcon,
  NotificationIcon,
  TranslateIcon,
  Dropdown,
  // AnalyticsOptionItemEllipse,
  SearchIcon,
  UserAvatar,
  // JobSeekerSidebar,
  User,
  Moil,
  // EmployerSidebar,
  Newmoilsvg,
  profilephoto1,
  fivestars,
};
